import {Component, EventEmitter, Input, Output} from '@angular/core';
@Component({
  selector: 'cm-list-editor',
  template: `
      <div class="d-flex no-gutters">
        <mat-form-field floatLabel="always" class="col" >
          <input name="add-new-element"
                 matInput
                 [required]="isRequired && (!list || !list.length)"
                 placeholder="{{placeholder}}"
                 [(ngModel)]="newElement">
        </mat-form-field>
        <button mat-mini-fab color="primary" [disabled]="!newElement"
                (keyup.enter)="newElement && addNewElement()"
                (click)="newElement && addNewElement()">
          <i class="fas fa-plus"></i>
        </button>
      </div>
	    <div class="mat-chip-list mb-4">
        <mat-basic-chip *ngFor="let element of list; let i = index" class="mat-basic-chip d-flex no-gutters">
           {{element}} 
          <span (click)="removeElement(i)" class="remove-chip">
            <i class="fas fa-times text-danger" aria-hidden="true"></i>
          </span>
        </mat-basic-chip>
	    </div>
  `,
})
export class ListEditorComponent {

  @Output()
  public listUpdated: EventEmitter<string[]> = new EventEmitter();

  @Input()
  public list: string[];

  @Input()
  public placeholder = 'Add new element';

  @Input()
  public isRequired = false;

  public newElement = '';

  constructor() {
    if (this.list) {
      this.list.sort();
    }
  }

  addNewElement() {
    if (!this.list) {
      this.list = [];
    }
    this.list.push(this.newElement);
    this.list.sort();
    this.newElement = '';
    this.listUpdated.emit(this.list);
  }

  removeElement(index: number) {
    this.list.splice(index, 1);
    this.listUpdated.emit(this.list);
  }

}
